<script lang="ts">
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';
	import { resolve } from '$app/paths';

	import constants from '@repo/sharedlib/src/utils/constants';
	import IonIcon from '@ui-components/ui/IonIcon.svelte';

	interface Props {
		signInHandler: () => void;
		signUpHandler: () => void;
	}

	function smoothScrollTo(elementId: string) {
		// Only run in browser environment
		if (!browser) return;

		const element = document.getElementById(elementId);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}

	const { signInHandler, signUpHandler }: Props = $props();
</script>

<!-- Navigation Links -->
<div class="flex flex-wrap justify-center items-center gap-6 md:gap-10">
	<a
		href={resolve('/blog')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Blog
	</a>
	<a
		href={resolve('/help')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		User Guide
	</a>
	<button
		onclick={() => smoothScrollTo('meeting-notes')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Features
	</button>
	<button
		onclick={() => smoothScrollTo('pricing')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Pricing
	</button>

	<a
		href={constants.DOWNLOAD_URL_MACOS}
		rel="external"
		data-sveltekit-reload
		onclick={() => setTimeout(() => goto('/download?skip=1&platform=macos'), 2000)}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Download macOS
	</a>
	<a
		href={constants.DOWNLOAD_URL_WINDOWS}
		rel="external"
		data-sveltekit-reload
		onclick={() => setTimeout(() => goto('/download?skip=1&platform=windows'), 2000)}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Download Windows
	</a>
	<button
		onclick={signInHandler}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Sign In
	</button>
	<button
		onclick={signUpHandler}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Sign Up
	</button>
</div>

<!-- Social Media Icons -->
<div class="flex justify-center text-center items-center gap-6 md:gap-7 w-full my-4">
	<!-- Instagram -->
	<div
		data-type="Instagram"
		class="size-5 relative overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
	>
		<IonIcon name="instagram_logo" myClass="size-5 text-white" />
	</div>

	<!-- YouTube -->
	<div
		data-type="YouTube"
		class="size-5 relative overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
	>
		<IonIcon name="youtube_logo" myClass="size-5 text-white" />
	</div>

	<!-- LinkedIn -->
	<a
		href="https://linkedin.com/company/retainapp"
		target="_blank"
		rel="noopener noreferrer"
		data-type="Linkedin"
		class="size-5 relative overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
	>
		<IonIcon name="linkedin_logo" myClass="size-5 text-white" />
	</a>

	<!-- Facebook -->
	<div
		data-type="Facebook"
		class="size-5 relative overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
	>
		<IonIcon name="fb_logo" myClass="size-5 text-white" />
	</div>

	<!-- X/Twitter -->
	<a
		href="https://x.com/retain_ai"
		target="_blank"
		rel="noopener noreferrer"
		data-type="X/Twitter"
		class="size-5 relative overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
	>
		<IonIcon name="twitter_x_logo" myClass="size-5 text-white" />
	</a>
</div>

<!-- Contact and Legal -->
<div class="flex flex-col justify-start items-center gap-3 md:gap-4 pt-4 pb-0">
	<a
		href={resolve('/terms-of-service')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Terms of Service
	</a>
	<a
		href={resolve('/privacy-policy')}
		class="justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose cursor-pointer hover:opacity-80 transition-opacity"
	>
		Privacy Policy
	</a>
	<div
		class="opacity-40 justify-start text-white text-[15px] font-normal font-['Instrument_Sans'] leading-loose"
	>
		© 2024-2025 CozyIntellect Inc. All rights reserved.
	</div>
</div>
